import React from 'react';
// import { createContext } from 'react';
// import { createContextualCan } from '@casl/react';
// import ability from '../../helpers/ability';
import { useProfile } from 'models';

// export const AbilityContext = createContext(ability);

// export default createContextualCan(AbilityContext.Consumer);

export default function({children, do: permission}){
  const profile = useProfile();

  if(profile.havePermission(permission)){
    return <>{children}</>;
  }  

  return <></>;
}